module.exports = __webpack_public_path__ + "img/hyy.6a12c47c.png";